<mat-toolbar class="topbar">
  <button mat-icon-button (click)="menuToggle.emit()" aria-label="Toggle menu">
    <mat-icon>menu</mat-icon>
  </button>

  <img src="logo.png" alt="Logo" height="24" />

  <span class="spacer"></span>

  <button mat-button (click)="onNavigateToProfile()" class="profile-btn" aria-label="My Profile">
    <mat-icon>account_circle</mat-icon>My Profile
  </button>
</mat-toolbar>
